import { ButtonProps } from 'types';

export const buttonBorderRadiusBySizeDecorator = ({ size }: ButtonProps) => {
	switch (size) {
		case 'small':
			return 'border-radius: 0.6rem;';
		case 'large':
			return 'border-radius: 2.4rem;';
		case 'medium':
		default:
			return 'border-radius: 1.6rem;';
	}
};
